import script from "./PageHeaders.vue?vue&type=script&lang=js"
export * from "./PageHeaders.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__